<template>
  <div class="tw-flex tw-size-full tw-items-center tw-justify-center">
    <span class="tw-text-sm tw-italic tw-text-gray-medium">
      {{ message || 'Nothing Selected Yet' }}
    </span>
  </div>
</template>

<script setup lang="ts">
/**
 * EmptySelectionState - Reusable empty state component for multi-selectors
 *
 * Used in the right pane of multi-selector modals when no items are selected.
 * Provides consistent styling and message across all multi-selector components.
 *
 * @example
 * ```vue
 * <template #right>
 *   <EmptySelectionState v-if="!selectedItems.length" />
 * </template>
 * ```
 *
 * @example Custom message
 * ```vue
 * <EmptySelectionState message="No items chosen" />
 * ```
 */

interface Props {
  /** Custom message to display. Defaults to "Nothing Selected Yet" */
  message?: string;
}

defineProps<Props>();
</script>
